import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function Masovian() {
  return (
    <>
      <DisplayMaster voivodeship="Masovian" />
    </>
  );
}